export const validHexCode = /^#(([A-F0-9]{2}){3,4}|[A-F0-9]{3})$/i;
